import { FAQDtotoFAQ } from '../../../mappers/faq';
import { api } from '../api';
export const FaqApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getFaqById: builder.query({
            query: ({ id }) => ({
                url: `api/FAQ/${id}`,
                method: 'get',
            }),
            transformResponse: (response) => FAQDtotoFAQ(response),
            providesTags: ['Faq'],
        }),
        addFaq: builder.mutation({
            query: Faq => ({
                url: 'api/FAQ/',
                method: 'post',
                data: {
                    FAQCategoriaId: Faq.faqCategorieId,
                    Titulo: Faq.title,
                    Descricao: Faq.desc,
                    Conteudo: Faq.htmlContent,
                    Ordem: Faq.index,
                },
            }),
            invalidatesTags: ['Faq'],
        }),
        updateFaq: builder.mutation({
            query: Faq => ({
                url: `api/FAQ/${Faq.id}`,
                method: 'put',
                data: {
                    FAQCategoriaId: Faq.faqCategorieId,
                    Titulo: Faq.title,
                    Descricao: Faq.desc,
                    Conteudo: Faq.htmlContent,
                    Ordem: Faq.index,
                },
            }),
            invalidatesTags: ['Faq'],
        }),
        deleteFaq: builder.mutation({
            query: ({ id }) => ({
                url: `api/FAQ/${id}`,
                method: 'delete',
            }),
            invalidatesTags: ['Faq'],
        }),
    }),
});
export const { useGetFaqByIdQuery, useAddFaqMutation, useUpdateFaqMutation, useDeleteFaqMutation, } = FaqApi;
